import { DueOutCategoryCount, DueOutFetchArgs, getDueoutGroupByCounts } from '../../assets/ts/data/dueout/dueout'
  import useServerData from '../use-server-data'
  
  function useDueoutorderByCounts(fetchArgs: DueOutFetchArgs) {
    const {
      data: dueOutCount,
      error: dueOutCountError,
      fetchData: fetchDueOutCount,
      isLoading: dueOutCountIsLoading,
  
    } = useServerData<DueOutCategoryCount, DueOutFetchArgs>(
      getDueoutGroupByCounts,
      fetchArgs
    )
  
    return {
        dueOutCount, // retained for backward-compatibility.  Use inquiryCountValue
      dueOutCountError,
      dueOutCountIsLoading,
      fetchDueOutCount
    }
  }
  
  export default useDueoutorderByCounts
  